export const isValidEmail = text =>
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    text
  )

export const isNonEmptyString = text => {
  if (typeof text === 'string') {
    return text.trim().length > 0
  }
  return false
}

export const isNumber = text => /^-{0,1}\d+(\.\d+){0,1}$/.test(text)



// WEBPACK FOOTER //
// ./src/helpers/validation.js